import { render } from "./BlocklistPage.vue?vue&type=template&id=021a2f52&ts=true"
import script from "./BlocklistPage.vue?vue&type=script&lang=ts"
export * from "./BlocklistPage.vue?vue&type=script&lang=ts"

import "./BlocklistPage.vue?vue&type=style&index=0&id=021a2f52&lang=css"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__